var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiIcon, UiButton, UiSpinner } from '@claims-ia/design-system';
import EquipmentForm from '@declaration/components/equipment/EquipmentForm.vue';
import Modal from '@declaration/components/UI/Modal.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
const equipment = namespace('equipment');
const settings = namespace('settings');
const qualification = namespace('qualification');
let EquipmentModal = class EquipmentModal extends Vue {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.isDeleting = false;
        this.arePhotosValid = false;
        this.validateRequested = false;
    }
    created() {
        this.arePhotosValid = this.requiredPhotos === 0;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get equipment() {
        return this.change.data;
    }
    onPhotosValidChange(valid) {
        this.arePhotosValid = valid;
    }
    get requiredPhotos() {
        if (!this.setting)
            return 0;
        const trigram = this.trigram;
        if (!trigram)
            return 0;
        let rawValue = null;
        try {
            rawValue = this.setting(`damageRequiredPhotosCount${trigram}`);
        }
        catch (_a) {
            rawValue = null;
        }
        if (rawValue === undefined || rawValue === null) {
            try {
                const groupedSetting = this.setting('damageRequiredPhotosCount');
                if (groupedSetting && typeof groupedSetting === 'object') {
                    rawValue = groupedSetting[trigram];
                }
            }
            catch (_b) {
                rawValue = null;
            }
        }
        const value = Number(rawValue);
        return isNaN(value) ? 0 : value;
    }
    get isValid() {
        // make assertion on name because when the modal is initially open,
        // the store is considered as valid as no object is created
        const baseValid = this.validation.isValid && !!this.equipment.name;
        const result = this.requiredPhotos === 0 ? baseValid : baseValid && this.arePhotosValid;
        return result;
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateEquipment(this.changeKey);
        this.validateRequested = true;
    }
    async save() {
        this.isSaving = true;
        try {
            await this.saveChanges();
            this.closeModal();
        }
        catch (err) {
            this.$store.dispatch('error/add', this.$tc('error.snackbar.info'));
        }
        this.isSaving = false;
    }
    closeModal() {
        this.$emit('close');
    }
    onClose() {
        this.validateRequested = false;
        this.closeModal();
    }
    confirmDeletion() {
        const deleteCallback = async () => {
            this.isDeleting = true;
            await this.deleteEquipment(this.changeKey);
            // Delete from backend if it is persisted
            if (this.changeKey !== null) {
                await this.saveChanges();
            }
            this.closeModal();
            this.isDeleting = false;
        };
        this.confirmDelete(this.changeKey, deleteCallback);
    }
};
__decorate([
    equipment.Getter('change')
], EquipmentModal.prototype, "changeGetter", void 0);
__decorate([
    equipment.Getter('validation')
], EquipmentModal.prototype, "validationGetter", void 0);
__decorate([
    equipment.Action('saveChanges')
], EquipmentModal.prototype, "saveChanges", void 0);
__decorate([
    equipment.Action('validateAndRevealDamages')
], EquipmentModal.prototype, "validateEquipment", void 0);
__decorate([
    equipment.Action('updateDamage')
], EquipmentModal.prototype, "updateEquipment", void 0);
__decorate([
    equipment.Action('selectWithInitialCategory')
], EquipmentModal.prototype, "selectWithInitialCategory", void 0);
__decorate([
    equipment.Action('deleteDamage')
], EquipmentModal.prototype, "deleteEquipment", void 0);
__decorate([
    settings.Getter('setting')
], EquipmentModal.prototype, "setting", void 0);
__decorate([
    qualification.Getter('typeTrigram')
], EquipmentModal.prototype, "trigram", void 0);
__decorate([
    qualification.State('claim')
], EquipmentModal.prototype, "claim", void 0);
EquipmentModal = __decorate([
    Component({
        components: {
            Modal,
            RadioPrimaryButton,
            UiButton,
            EquipmentForm,
            UiIcon,
            UiSpinner,
        },
        props: {
            isDisplayed: { type: Boolean, required: true },
            changeKey: { type: [Number, String], default: null },
            confirmDelete: { type: Function, required: true },
        },
    })
], EquipmentModal);
export default EquipmentModal;
